import { apiClient } from '../../utils';

export const removeMedia = async (hh) =>
  apiClient.post('/media/remove', { data: { hh } });
